import * as yup from 'yup'

export const schemaDialogRipds = (isRequired) => {
  return yup.object().shape({
    ...(isRequired && { receiverEmail: yup.string().email().required() }),
  })
}
